































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { VForm } from '@/interfaces';

@Component
export default class ErrorEventDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
}
